"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeadFormPaymentDetails = void 0;
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
class LeadFormPaymentDetails extends base_models_1.Serializable {
}
exports.LeadFormPaymentDetails = LeadFormPaymentDetails;
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsIBAN)(),
    (0, base_models_1.Docs)({ example: 'NL52INGB7134534839', description: 'the iban of the customer' }),
    (0, class_transformer_1.Expose)({ name: 'iban' }),
    tslib_1.__metadata("design:type", String)
], LeadFormPaymentDetails.prototype, "iban", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: 'J. Jansen.', description: 'the account holder of the iban' }),
    (0, class_transformer_1.Expose)({ name: 'account_holder' }),
    tslib_1.__metadata("design:type", String)
], LeadFormPaymentDetails.prototype, "accountHolder", void 0);
